import React, {useEffect, useState} from "react";
import {Menu, MenuButton, MenuItem, MenuItems} from "@headlessui/react";
import {ChevronDownIcon} from "@heroicons/react/16/solid/index";
import { COUNTRIES, COUNTRIES_NL_SORTED, countryByDialCode } from "../../types/countries.ts";
import type { Country } from "../../generated/enums.ts";

function getCountryByISO(iso: Country) {
    return COUNTRIES.find(country => country.iso === iso)
}

export function PhoneNumberField({onChangeFunc, defaultValue, ...props}) {
    const [selectedCountry, setSelectedCountry] = useState<Country>("NL");
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    useEffect(() => {
        setSelectedCountry(countryByDialCode(defaultValue.split(' ')[0].replace('+', ''))?.iso || "NL")
        setPhoneNumber(defaultValue.slice(defaultValue.indexOf(' ') + 1))
    }, []);

    useEffect(() => {
        onChangeFunc('+' + getCountryByISO(selectedCountry).code + ' ' + phoneNumber)
    }, [selectedCountry, phoneNumber]);

    return (

        <div className="flex items-center relative">
            <Menu as="div" className="relative inline-block text-left">
                <div>
                    <MenuButton
                        className="flex items-center gap-2 p-2 whitespace-nowrap w-full z-20 text-sm text-gray-900  rounded-s-md  border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-s-gray-700  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500">
                        <img src={`https://flagsapi.com/${getCountryByISO(selectedCountry).iso}/flat/16.png`}
                             alt={getCountryByISO(selectedCountry).nameNl}/>
                        +{getCountryByISO(selectedCountry).code}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 h-5 w-5 text-gray-400"/>
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute left-0 z-10 mt-2 w-96 origin-top-right rounded-md max-h-64 overflow-y-scroll bg-white shadow-lg ring-1 ring-black ring-opacity-5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        {
                            //@ts-ignore
                            COUNTRIES_NL_SORTED.map((country) => <MenuItem onClick={(e) => setSelectedCountry(country.iso)}>
                            <span
                                className="flex gap-2 px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900"
                            >
                                <img loading="lazy" src={`https://flagsapi.com/${country.iso}/flat/16.png`}
                                     alt={country.nameNl}/>
                                {country.nameNl} (+{country.code})
                            </span>
                        </MenuItem>)}

                    </div>
                </MenuItems>
            </Menu>

            <label htmlFor="phone-input" className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Phone
                number:</label>
            <div className="relative w-full">
                <input type="text" id="phone-input" defaultValue={phoneNumber}
                       className="block p-2 w-full z-20 text-sm text-gray-900  rounded-e-md border-s-0 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-s-gray-700  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500"
                       pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" required onChange={(e) => setPhoneNumber(e.target.value)}/>
            </div>
        </div>

    )
}
